const formatVideoDuration = (duration: any) => {
  const seconds = parseFloat(duration);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  let durationString = "PT";

  if (hours > 0) {
    durationString += `${hours}H`;
  }

  if (minutes > 0) {
    durationString += `${minutes}M`;
  }

  if (remainingSeconds > 0 || (hours === 0 && minutes === 0)) {
    durationString += `${remainingSeconds}S`;
  }

  return durationString;
};

function convertToJpg(path: string) {
  const parts = path.split(".");
  parts[parts.length - 1] = "jpg";
  return parts.join(".");
}

function isYouTubeLink(url: string) {
  const youtubePatterns = [
    /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=[\w-]+/,
    /^(https?:\/\/)?(www\.)?youtu\.be\/[\w-]+/,
    /^(https?:\/\/)?(www\.)?youtube\.com\/embed\/[\w-]+/,
    /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=[\w-]+&feature=music/,
    /^(https?:\/\/)?(m\.)?youtube\.com\/watch\?v=[\w-]+/,
  ];

  return youtubePatterns.some((pattern) => pattern.test(url));
}

// eslint-disable-next-line func-names
const getThumb = function (url: any, size: any) {
  if (url === null) {
    return "";
  }
  size = size === null ? "big" : size;
  const results = url?.match("[\\?&]v=([^&#]*)");
  const video = results === null ? url : results[1];

  if (size === "small") {
    return `http://img.youtube.com/vi/${video}/2.jpg`;
  }
  return `http://img.youtube.com/vi/${video}/0.jpg`;
};

const timestampToDate = (timestamp: any) => {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getThumbnail = (path: any, thumbnail_url: any, platform: string) => {
  const cloudinaryPrefixUrl = "https://res.cloudinary.com/amberstudent/video/upload/";

  if (isYouTubeLink(path)) {
    return getThumb(path, "big");
  }

  if (!thumbnail_url) {
    const convertedPath = convertToJpg(path);
    return `${platform === "gumlet" ? "" : cloudinaryPrefixUrl}${convertedPath}`;
  }

  return thumbnail_url;
};

// function to generate schema content for an image
const getGalleryVideoSchema = (
  name = "",
  contentUrl = "",
  description = "",
  thumbnailUrl = "",
  upload_date = "",
  duration = "",
) => {
  const data: any = {
    "@context": "https://schema.org/",
    "@type": "VideoObject",
  };

  if (name) {
    data.name = name;
  }
  if (contentUrl) {
    data.contentUrl = contentUrl;
  }
  if (description) {
    data.description = description;
  }
  if (thumbnailUrl) {
    data.thumbnailUrl = thumbnailUrl;
  }

  if (upload_date) {
    data.uploadDate = upload_date;
  }

  if (duration) {
    data.duration = formatVideoDuration(duration);
  }

  data.publisher = {
    "@type": "Organization",
    name: "amber",
  };

  return data;
};

const generateVideoSchemaData = (inventoryData: any = {}) => {
  const videos = inventoryData?.videos?.length > 0 ? [...inventoryData?.videos] : [];

  inventoryData?.children_short?.forEach((child: any) => {
    if (child?.videos?.length > 0) {
      videos.push(...child.videos);
    }
  });

  let videoSchemaData = [];

  if (videos?.length > 0) {
    videoSchemaData = videos.map((video) =>
      getGalleryVideoSchema(
        video?.caption || inventoryData?.name,
        video?.path,
        video?.description,
        getThumbnail(video?.path, video?.thumbnail_url, video?.platform),
        video?.upload_date || timestampToDate(inventoryData?.created_at),
        video?.duration,
      ),
    );
  }

  return videoSchemaData;
};

export default generateVideoSchemaData;
